module.exports = __webpack_public_path__ + "img/arrow_right.599eda42.svg";